import React, { Component } from "react";

import { SellToWebAdminModalDialogComponent } from "../common/selltowebmodaldialog/SellToWebAdminModalDialogComponent";
import { SellToWebModalDialogHeaderButtonComponent } from "../common/selltowebmodaldialog/SellToWebModalDialogHeaderButtonComponent";
import { SellToWebAdminInputComponent } from "../common/selltowebinput/SellToWebAdminInputComponent";

import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";
import { SellToWebAdminDropdownComponent } from "../common/selltowebdropdown/SellToWebAdminDropdownComponent";

export class TenantOffersCRMDeliveryRawViewComponent extends Component {

    artifactData = [
        { key: "Offer", value: "Offer" },
        { key: "Confirmation", value: "Confirmation" }
    ];

    constructor(props) {
        super(props);

        this.state = {
            selectedArtifact: this.artifactData[0],
            crmContent: "",
            crmContentConfirmed: "",
            crmDeliveryEmail: "",
            crmDeliveryFormat: "",
            crmCallbackUrl: "",
            crmXmlContent: "",
            crmXmlContentConfirmed: ""
        };

        this.onArtifactClick = this.onArtifactClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            if (this.props.showCRMRawViewPopup && (this.props.crmContent || this.props.crmContentConfirmed) && (prevProps.crmContent !== this.props.crmContent || prevProps.crmContentConfirmed !== this.props.crmContentConfirmed)) {
                let crmContent = this.props.crmContent;
                let crmContentConfirmed = this.props.crmContentConfirmed;

                this.setState({
                    crmContent: crmContent,
                    crmContentConfirmed: crmContentConfirmed,
                    crmDeliveryEmail: crmContent?.CRMDeliveryEmail ?? "",
                    crmDeliveryFormat: crmContent?.CRMDeliveryFormat ?? "",
                    crmCallbackUrl: crmContent?.CRMCallbackUrl ?? "",
                    crmDeliveryEmailConfirmed: crmContentConfirmed?.CRMDeliveryEmail ?? "",
                    crmDeliveryFormatConfirmed: crmContentConfirmed?.CRMDeliveryFormat ?? "",
                    crmCallbackUrlConfirmed: crmContentConfirmed?.CRMCallbackUrl ?? "",
                    crmXmlContent: this.props.crmXmlContent ?? "",
                    crmXmlContentConfirmed: this.props.crmXmlContentConfirmed ?? ""
                });
            }
        } catch (error) {
            console.logError(error, "TenantOffersCRMDeliveryRawViewComponent", "componentDidUpdate");
        }
    }

    onArtifactClick(id, artifact) {
        try {
            this.setState({ selectedArtifact: artifact }, () => {
                if (!this.state.crmContentConfirmed) {
                    this.props.onConfirmedCRMDeliveryClick();
                }
            });
        }
        catch (error) {
            console.logError(error, "TenantOffersCRMDeliveryRawViewComponent", "onArtifactClick");
        }
    }

    onCancelClick(event) {
        try {
            this.setState({
                selectedArtifact: this.artifactData[0],
                crmDeliveryEmail: "",
                crmDeliveryFormat: "",
                crmCallbackUrl: "",
                crmDeliveryEmailConfirmed: "",
                crmDeliveryFormatConfirmed: "",
                crmCallbackUrlConfirmed: "",
                crmContent: "",
                crmContentConfirmed: "",
                crmXmlContent: "",
                crmXmlContentConfirmed: ""
            }, () => {
                this.props.onCancelCRMRawView(event);
            });
        }
        catch (error) {
            console.logError(error, "TenantOffersRouteComponent", "onCancelCRMRawView");
        }
    }

    render() {
        let deliveryEmail = this.state.selectedArtifact?.value === "Offer" ? this.state.crmDeliveryEmail : this.state.crmDeliveryEmailConfirmed;
        let deliveryFormat = this.state.selectedArtifact?.value === "Offer" ?  this.state.crmDeliveryFormat : this.state.crmDeliveryFormatConfirmed;
        let callbackUrl = this.state.selectedArtifact?.value === "Offer" ? this.state.crmCallbackUrl : this.state.crmCallbackUrlConfirmed

        return <SellToWebAdminModalDialogComponent
            title={this.props.rawViewCRMTitle}
            showDialog={this.props.showCRMRawViewPopup}
            className="admin-offers-crm-raw-view-dialog"
            onCancelClick={this.onCancelClick}
        >
            <SellToWebModalDialogHeaderButtonComponent>
                <button className="btn btn-primary admin-copy-button" onClick={(event) => this.props.onCopyCRMRawView(event)}>
                    Copy <span className="far fa-copy admin-icon" />
                </button>
            </SellToWebModalDialogHeaderButtonComponent>
            {
                ((this.state.crmContentConfirmed && this.state.crmXmlContentConfirmed) || (this.state.crmContent && this.state.crmXmlContent && this.state.selectedArtifact?.value === "Offer"))
                    ? <div className="admin-body">
                        <div className="card">
                            <div className="card-block">
                            <table className="admin-offers-crm-delivery-table-artifact">
                                <tbody>
                                    <tr>
                                        <td className="text-nowrap">
                                            Artifact:
                                        </td>
                                        <td className="admin-offers-crm-delivery-table-artifact">
                                            <SellToWebAdminDropdownComponent data={this.artifactData} itemKey="value" onItemClick={this.onArtifactClick} value={this.state.selectedArtifact !== null ? this.state.selectedArtifact.value : "Select Artifact"} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        <br />
                        <div className="card">
                            <div className="card-block">
                                <table className="admin-offers-crm-delivery-table">
                                    <tbody>
                                        <tr>
                                            <td className="text-nowrap">
                                                CRM Delivery Email:
                                            </td>
                                            <td className="admin-offers-crm-delivery-table-email">
                                                <SellToWebAdminInputComponent disabled value={deliveryEmail} colSpan="col-12" controlSpan="col-12" hideClear />
                                            </td>
                                            <td className="text-nowrap">
                                                CRM Delivery Format:
                                            </td>
                                            <td className="admin-offers-crm-delivery-table-format">
                                                <SellToWebAdminInputComponent disabled value={deliveryFormat} colSpan="col-12" controlSpan="col-12" hideClear />
                                            </td>
                                            <td className="text-nowrap">
                                                CRM Callback Url:
                                            </td>
                                            <td className="admin-offers-crm-delivery-table-url">
                                                <SellToWebAdminInputComponent disabled value={callbackUrl} colSpan="col-12" controlSpan="col-12" hideClear />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div className="card admin-offers-crm-raw-view-dialog-card">
                            <div className="card-block">
                                <p className="admin-offers-crm-content-label">CRM Delivery Content:</p>
                                {
                                    this.state.selectedArtifact?.value === "Confirmation"
                                        ? this.props.crmXmlContentConfirmed
                                            ? <div dangerouslySetInnerHTML={{ __html: this.props.crmXmlContentConfirmed }} />
                                            : "No CRM Delivery content available"
                                        : this.props.crmXmlContent
                                            ? <div dangerouslySetInnerHTML={{ __html: this.props.crmXmlContent }} />
                                            : "No CRM Delivery content available"
                                }
                            </div>
                        </div>
                    </div>
                    : <SellToWebSpinnerComponent showSpinner={(!this.state.crmXmlContent || !this.state.crmXmlContentConfirmed)
                        && (!this.state.crmContent || !this.state.crmContentConfirmed)} />
            }
        </SellToWebAdminModalDialogComponent>
    }
}